var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 12.5h1.666V8.333H9.167V12.5ZM10 15c.236 0 .434-.08.593-.24.16-.16.24-.357.24-.593a.804.804 0 0 0-.24-.594.804.804 0 0 0-.593-.24.804.804 0 0 0-.593.24.804.804 0 0 0-.24.594c0 .236.08.434.24.593.159.16.357.24.593.24Zm-6.292.833h12.584L10 5 3.708 15.833ZM.833 17.5 10 1.667 19.167 17.5H.833Z"
  })));
};

export default SvgWarning;